import { useState } from 'react';
import { Upload, ArrowRight, FileSpreadsheet, Users, Package } from '../../icons/wp-icons';
import MigrationWizard from './MigrationWizard';

function DatenImportSettings({ readOnly = false }) {
  const [showWizard, setShowWizard] = useState(false);

  return (
    <>
      <div className="bg-surface rounded-card shadow-card overflow-hidden">
        {/* Header */}
        <div className="p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-indigo-100 rounded-lg">
              <Upload className="w-6 h-6 text-indigo-600" />
            </div>
            <div>
              <h2 className="text-xl font-semibold">Daten importieren</h2>
              <p className="text-sm text-text-muted">
                Importieren Sie Kunden und Artikel aus anderen Programmen
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="text-sm text-text-muted">
            Der Wechsel-Assistent hilft Ihnen, Daten aus Ihrer bisherigen Software zu uebernehmen.
            Unterstuetzt werden: EasyFirma, Lexoffice, sevDesk, Bitec, VERAS sowie allgemeine CSV/Excel-Dateien und DATANORM-Kataloge.
          </p>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
              <Users className="w-5 h-5 text-indigo-600 mt-0.5" />
              <div>
                <div className="font-medium text-sm">Kunden</div>
                <div className="text-xs text-text-muted">Name, E-Mail, Adresse, Telefon</div>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
              <Package className="w-5 h-5 text-indigo-600 mt-0.5" />
              <div>
                <div className="font-medium text-sm">Artikel/Katalog</div>
                <div className="text-xs text-text-muted">Artikelnr, Preise, Kategorien</div>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
              <FileSpreadsheet className="w-5 h-5 text-indigo-600 mt-0.5" />
              <div>
                <div className="font-medium text-sm">DATANORM</div>
                <div className="text-xs text-text-muted">Lieferanten-Kataloge importieren</div>
              </div>
            </div>
          </div>

          {/* Start Button */}
          {!readOnly && (
            <button
              onClick={() => setShowWizard(true)}
              className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-primary text-white rounded-button font-medium hover:bg-primary-dark transition"
            >
              <Upload className="w-5 h-5" />
              Wechsel-Assistent starten
              <ArrowRight className="w-4 h-4" />
            </button>
          )}

          {readOnly && (
            <div className="p-3 bg-gray-100 rounded-lg text-sm text-text-muted text-center">
              Sie haben keine Berechtigung zum Importieren von Daten.
            </div>
          )}
        </div>
      </div>

      {/* Migration Wizard Modal */}
      {showWizard && (
        <MigrationWizard onClose={() => setShowWizard(false)} />
      )}
    </>
  );
}

export default DatenImportSettings;
